<template lang="pug">
.task-coupon-container(:class="{'new-module': newModule && !preparing}")
  template(v-if="tasks && tasks.length > 0")
    .tasks
      .task-item(v-for="(item, index) in tasks", :key="item.taskCode")
        template(v-if="item.shadow")
          .shadow-left
          .shadow-right
        template(v-else)
          .task-left.flex-mid
            .left.flex-mid
              template(v-if="newModule")
                img.icon(
                  :src="item.taskImgUrl ? item.taskImgUrl : 'https://m.hellobike.com/resource/helloyun/wb15250/w-2fMX6IbN.png?x-oss-process=image/quality,q_80'"
                )
              template(v-else)
                .icon-block
                  img.coin(
                    src="https://m.hellobike.com/resource/AppPlatformH5/fuli/McuKtqFNzr0bhHNNseHY8.png"
                  )
                  .amount.flex-mid
                    template(v-if="item.amount !== undefined")
                      span +
                      span.value {{ item.amount }}
            .mid(
              :class=`{
                'only-title': (!item.additionalDesc &&
                (item.status !== TaskStatus.DOING) &&
                (item.status !== TaskStatus.CAN_DONE))
              }`
            )
              template(v-if="newModule")
                .top.flex-mid
                  .title {{ item.title }}
                  .icon-block.flex-mid
                    img.coin(
                      src="https://m.hellobike.com/resource/AppPlatformH5/fuli/McuKtqFNzr0bhHNNseHY8.png"
                    )
                    .amount
                      template(v-if="item.amount !== undefined")
                        span +
                        span.value {{ item.amount }}
              template(v-else)
                .title {{ item.title }}
              .progress
                .progress-info(v-if='!!item.additionalDesc') {{ item.additionalDesc }}
                template(
                  v-if="item.status === TaskStatus.DOING"
                )
                  .progress-text
                    .surplus.colored {{ item.surplus | surplusTime }}
                    .progress
                      span.colored 进度
                      span.colored {{ item.process }}
                      span /{{ item.target }}
                template(
                  v-if="item.status === TaskStatus.CAN_DONE"
                )
                  .progress-text
                    .surplus.colored 已完成
          .right.flex-mid
            .btn.flex-mid(
              @click="clickTaskV2(item, index)",
              :class=`{
                  disabled: item.disabled,
                  'to-accept': item.status === TaskStatus.TO_ACCEPT,
                  doing: item.status === TaskStatus.DOING,
                  'can-done': item.status === TaskStatus.CAN_DONE
                }`
            ) {{ item.buttonName }}
    template(v-if='this.frameTask')
    template(v-else)
      .more.flex-mid(
        v-if="!preparing && data && data.length > num",
        @click="seeMore"
      )
        template(v-if="!showMore")
          span 查看更多任务
          .common-arrow-down
        template(v-else)
          span 收起
          .common-arrow-up
  template(v-else)
    Empty
</template>

<script>
import { Native, env } from '@hb/NBridge/lib/h5';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import Empty from '@/components/empty';
import Toast from '@/components/toast';
import { getTokenAndKey, getCityInfo, getTokenAndLocation } from '@/utils/index';
import { mapTaskV2, mapBusinessInfo } from '@/utils/mappers';
import { TaskStatus } from '@/const/task';
import { acceptTaskV2, getTaskAward } from '@/api/bounty';
import { getVersion, getSystemCode } from '@/utils/systemCode';
import {
  jumpEvent,
} from '@/api/lottery';
import dayjs from 'dayjs';
import { welfareGo } from '../utils';
import { ParamsUtil } from '../../../utils/params';

export default {
  name: 'BountyTaskCoupon',
  components: {
    Empty,
  },
  filters: {
    surplusTime(date) {
      const endTime = dayjs(date).unix();
      const currentTime = Date.now() / 1000;
      let time = (endTime - currentTime)
       / (1 * 24 * 60 * 60) + 1;
      time = parseInt(time, 10);
      return `剩余${time}天`;
    },
  },
  props: {
    newModule: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: () => [],
    },
    preparing: {
      type: Boolean,
      default: true,
    },
    frameTask: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      TaskStatus,
      btnText: {
        [TaskStatus.TO_ACCEPT]: '领任务',
        [TaskStatus.DOING]: '做任务',
        [TaskStatus.CAN_DONE]: '领奖励',
      },
      showMore: false,
      isMP: false,
    };
  },
  computed: {
    tasks() {
      if (this.preparing) {
        return [{ shadow: true }, { shadow: true }, { shadow: true }];
      }
      if (!this.data || this.data.length === 0) {
        return [];
      }
      if (this.data.length <= 1 || this.showMore) {
        return this.data;
      }
      // app和小程序单独处理
      return this.data.slice(0, this.num);
    },
    num() {
      if (this.isMP) {
        if (!this.newModule) {
          return 1;
        }
      } if (this.frameTask) {
        return 2;
      }
      return 3;
    },
  },
  watch: {
    tasks: {
      deep: true,
      handler() {
        if (this.tasks && this.tasks.length > 0) {
          this.tasks.forEach((item) => {
            try {
              UBT.moduleExpose({
                pageId: 'Welfare',
                categoryId: 'platform',
                moduleId: 'welfare_task',
                contentId: 'welfare_task',
                exposureTimes: 1,
                businessInfo: {
                  task_qua: this.tasks.length,
                  taskgroupcode: item.taskGroupCode,
                  task_code: item.taskCode,
                  task_name: item.taskName,
                  adsource: ParamsUtil.getParam('adsource'),
                },
              });
            } catch (error) {
              //
            }
          });
        }
      },
    },
  },
  mounted() {
    if (env.isAliMP || env.isAliMPMonitor) {
      this.isMP = true;
    }
  },
  methods: {
    seeMore() {
      UBT.clickButton({
        pageId: 'Welfare',
        buttonName: 'more_task',
        categoryId: 'platform',
        businessInfo: {},
      });
      this.showMore = !this.showMore;
    },
    async clickTaskV2(item, index) {
      UBT.clickButton({
        pageId: 'Welfare',
        buttonName: 'welfare_task_clic',
        categoryId: 'platform',
        businessInfo: {
          clic_type: item.status,
          taskgroupcode: item.taskGroupCode,
          task_code: item.taskCode,
          task_name: item.taskName,
          adsource: ParamsUtil.getParam('adsource'),
        },
      });
      if (!item || item.disabled) {
        return;
      }
      if (item.status === TaskStatus.DOING) {
        this.close();
      }

      let UBTButtonName = 'market_task_clickreceive';
      if (item.status === TaskStatus.DOING) {
        UBTButtonName = 'market_task_clicktodo';
      } else if (item.status === TaskStatus.CAN_DONE) {
        UBTButtonName = 'market_task_getrewards';
      }
      UBT.clickButton({
        pageId: 'platform_bounty',
        buttonName: UBTButtonName,
        categoryId: 'platform',
        businessInfo: mapBusinessInfo(item),
      });
      if (item.shouldAccept) {
        const { token } = await getTokenAndKey();
        UBT.clickButton({
          pageId: 'Welfare',
          buttonName: 'market_task_clickreceive',
          categoryId: 'market',
          businessInfo: mapBusinessInfo(item),
        });
        const { taskGroupCode, taskCode, expertId } = item;
        acceptTaskV2({
          token,
          channelId: env.platformCode,
          sceneNameEn: 'platform_points',
          subSceneNameEn: 'platform_points_pointshp',
          version: await getVersion(),
          ...(await getCityInfo()),
          taskList: [
            {
              taskCode,
              taskGroupCode,
              expertId,
            },
          ],
        })
          .then((res) => {
            Toast.show('任务领取成功');
            if (res && res.data && res.data.taskList && res.data.taskList[0]) {
              const task = mapTaskV2(res.data.taskList[0]);
              const {
                status,
                process,
                target,
                shouldAccept,
                buttonName,
                end,
                surplus,
              } = task;
              Object.assign(this.data[index], {
                status,
                process,
                target,
                shouldAccept,
                buttonName,
                end,
                surplus,
              });
            } else {
              Toast.show('查询任务信息失败');
              Object.assign(this.data[index], {
                status: TaskStatus.DOING,
                buttonName: this.btnText[TaskStatus.DOING],
                shouldAccept: false,
              });
            }
          })
          .catch((e) => {
            Toast.show(e && e.message ? e.message : '任务领取失败');
          });
      } else {
        if (item.status === TaskStatus.CAN_DONE) {
          const { token } = await getTokenAndKey();
          UBT.clickButton({
            pageId: 'Welfare',
            buttonName: 'market_task_getrewards',
            categoryId: 'market',
            businessInfo: mapBusinessInfo(item),
          });
          const { taskGuid, taskGroupCode } = item;
          getTaskAward({
            token,
            channelId: env.platformCode,
            taskGuid,
            taskGroupCode,
            version: await getVersion(),
          })
            .then(() => {
              Toast.show(`任务奖励领取成功，+${item.amount}奖励金`);
              Object.assign(this.data[index], {
                buttonName: '已领取',
                disabled: true,
              });
            })
            .catch((e) => {
              Toast.show(`${(e && e.message) || '任务奖励领取失败'}`);
            });
          return;
        }
        if (item.status === TaskStatus.DOING) {
          UBT.clickButton({
            pageId: 'Welfare',
            buttonName: 'market_task_clicktodo',
            categoryId: 'market',
            businessInfo: mapBusinessInfo(item),
          });
          if (item.taskActivityType === 1 && item.marketPlan !== 'weibo_browse') {
            let channel = 'app';
            if (env.isAliMP || env.isAliMPMonitor) {
              channel = 'ali';
            }
            const data = await getTokenAndLocation();
            const { token, adCode, cityCode } = data;
            try {
              const res = await jumpEvent({
                token,
                cityCode, // 021
                adCode, // '310112'
                channelId: env.platformCode,
                systemCode: getSystemCode(),
                version: await getVersion(),
                btnLink: item.btnLink[channel],
                taskCode: item.taskCode,
                sceneNameEn: 'weekly_cash',
                subSceneNameEn: 'weekly_cash_app',
                browseDuration: item.browseDuration,
              });
              if (res.success) {
                const link = item.btnLink[channel] || item.titleBarUrl;
                if (channel === 'ali') {
                  Native.callNative({
                    method: 'goOperationUrlV2',
                    params: link,
                  });
                } else {
                  window.onpageshow = null;
                  // eslint-disable-next-line no-unused-vars
                  window.onpageshow = (event) => {
                    window.location.reload();
                  };
                  window.location.href = link;
                }
              }
            } catch (e) {
              Toast.show(e && e.message ? e.message : '任务领取失败');
            }
          } else {
            let channel = 'app';
            if (env.isAliMP || env.isAliMPMonitor) {
              channel = 'ali';
            }
            const link = item.btnLink[channel] || item.titleBarUrl;
            if (channel === 'ali') {
              Native.callNative({
                method: 'goOperationUrlV2',
                params: link,
              });
            } else if (item.marketPlan === 'weibo_browse') {
              Native.openThirdWeb({ url: link });
            } else {
              welfareGo(link);
            }
          }
        }
      }
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}

.task-coupon-container {
  width: 100%;

  .more {
    font-size: 0.12rem;
    color: #999;
    margin-top: 0.15rem;

    * {
      border-color: #999 !important;
    }
  }

  .empty {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 0.12rem;
    color: #ccc;
    padding-bottom: 0.2rem;

    img {
      width: 0.78rem;
      height: 0.68rem;
      margin-bottom: 0.08rem;
    }
  }

  .shadow-left {
    width: 0.44rem;
    height: 0.45rem;
    background: #f7f9fa;
    border-radius: 0.04rem;
  }

  .shadow-right {
    width: 2.64rem;
    height: 0.33rem;
    background: #f7f9fa;
    border-radius: 0.04rem;
  }

  .task-item {
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 100%;
    align-items: center;
    position: relative;

    &:not(:first-of-type) {
      margin-top: 0.16rem;
    }

    .left {
      display: flex;
      flex-direction: column;
      margin-right: 0.12rem;

      .icon-block {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        width: 0.44rem;
        height: 0.46rem;
        background: rgba(254, 244, 231, 0.71);
        border-radius: 0.06rem;
        padding-top: 0.06rem;
        padding-bottom: 0.03rem;

        .coin {
          width: 0.22rem;
          height: 0.22rem;
        }

        .amount {
          font-size: 0.12rem;
          font-weight: bold;
          color: #fb990f;

          .value {
            font-family: "DIN Alternate Bold", sans-serif;
          }
        }
      }
    }

    .mid {
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      flex: 1;
      max-width: 1.9rem;
      // overflow: hidden;
      align-items: flex-start;

      .title {
        max-width: 1.9rem;
        font-size: 0.14rem;
        line-height: 0.16rem;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
      }

      .progress {
        align-items: center;

        .progress-info {
          height: 0.11rem;
          font-size: 0.11rem;
          font-weight: 400;
          color: #879099;
          line-height: 0.11rem;
          margin: 0.08rem 0 0.08rem 0;
        }
      }

      .progress-text {
        display: flex;

        .surplus {
          margin-right: 0.08rem;
          font-size: 0.11rem;
          font-weight: 400;
          color: #ff5526;
          line-height: 0.11rem;
        }

        .progress {
          font-size: 0.11rem;
          margin-left: 0.02rem;
          font-weight: 400;
          color: #879099;
          line-height: 0.11rem;
          letter-spacing: 1px;

          .colored {
            color: #ff5526;
          }
        }
      }
    }

    .right {
      flex-direction: column;
      align-items: flex-end;

      .btn {
        width: 0.62rem;
        height: 0.24rem;
        font-size: 0.12rem;
        font-weight: 500;
        border-radius: 0.13rem;
        line-height: 0.12rem;

        &.disabled {
          background: #f0f3f5 !important;
          color: #bcc4cc !important;
        }

        &.to-accept {
          background: #ffeee9;
          color: #ff5526;
        }

        &.doing {
          color: #ff5526;
          border: 0.01rem solid #ff5526;
        }

        &.can-done {
          background: linear-gradient(270deg, #ff7e32 0%, #ff5100 100%);
          color: rgba(255, 255, 255, 1);
        }
      }
    }
  }

  &.new-module {
    margin-bottom: 0.1rem;

    .icon {
      width: 0.48rem;
      height: 0.52rem;
    }

    .task-item {
      align-items: center;

      .task-left {
        align-items: start;
      }

      &:not(:first-of-type) {
        padding-top: 0.16rem;
        border-top: 0.01rem solid #f7f9fa;
      }

      .left {
        margin-right: 0.08rem;
      }

      .mid {
        .progress {
          .progress-info {
            margin: 0.07rem 0 0.07rem 0;
            height: 0.11rem;
            font-size: 0.11rem;
            font-weight: 400;
            color: #879099;
            line-height: 0.11rem;
            max-width: 1.65rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .progress-text {
            margin-top: 0.07rem;

            .surplus {
              font-size: 0.11rem;
              font-weight: 400;
              color: #ff5526;
              line-height: 0.11rem;
            }

            .progress {
              line-height: 0.11rem;

              .colored {
                color: #ff5526;
              }
            }
          }
        }

        .top {
          align-items: start;

          .title {
            max-width: 1.45rem;
            font-size: 0.14rem;
            font-weight: 500;
            color: #242729;
            line-height: 0.14rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .icon-block {
            margin: 0 0.01rem 0 0.06rem;
            position: relative;
            top: -0.01rem;

            .coin {
              max-width: 0.16rem;
              max-height: 0.16rem;
            }

            .amount {
              line-height: 0.12rem;
              font-weight: 500;
              font-size: 0.12rem;
              color: #ff5526;
              margin: 0 0.07rem 0 0.02rem;

              .value {
                position: relative;
                bottom: -0.002rem;
              }
            }
          }
        }
      }

      .only-title {
        margin-top: 0.18rem;
      }

      .right {
        .btn {
          &.to-accept {
            border: 0.01rem solid #ff5526;
            background: transparent;
          }
        }
      }
    }
  }
}
</style>
